<!-- filepath: c:\Users\admin\Documents\Work\supplies-management-fe\src\components\shared\BaseLoading.vue -->
<template>
  <div class="loading-container" v-if="visible">
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'BaseLoading',
  props: {
    visible: {
      type: Boolean,
      default: true, // Hiển thị loading mặc định
    },
  },
};
</script>

<style scoped>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8); /* Màu nền mờ */
  z-index: 9999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3; /* Màu viền nhạt */
  border-top: 5px solid #3498db; /* Màu viền xoay */
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
